import { AuthApi } from "./Admin/AuthApi";
import { BotApi } from "./Bot/BotApi";
import { ConversationApi } from "./Conversation/ConversationApi";
import { DashboardApi } from "./Dashboard/DashboardApi";
import { FlowApi } from "./Flow/FlowApi";
import { LeadApi } from "./Lead/LeadApi";

export const apiServices = [
  AuthApi,
  BotApi,
  ConversationApi,
  FlowApi,
  DashboardApi,
  LeadApi,
];
